/* @flow strict */

import * as React from 'react';
import SettingsPagePayment from './pay';
import SettingsPageLang from './lang';
import SettingsPageOrg from './org';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import SettingsNavigation from './navigation';
import { ReferralsTable } from './table';
import ReferralForm from './referral';
import './styles.scss';
import _ from 'lodash';

const queryString = require('query-string');

export const SettingsPageReferrals = ({ }: PropsType): React.Element<'div'> => {
  const [isReferralFormOpen, handleToggleReferralModal] = React.useState(false);

  React.useEffect(() => {
    handleToggleReferralModal(_.has(queryString.parse(location.search), 'edit'));
  }, []);

  return (
    <div className="sparxo-router-content">
      <div className="sparxo-page-container SettingsPage">
        <SettingsNavigation viewTab={'referrals'} />
        <ReferralsTable
          isFormOpen={isReferralFormOpen}
          handleOpenReferralModal={(): void => handleToggleReferralModal(true)}
        />
        {
          isReferralFormOpen &&
          <ReferralForm
            isOpen={isReferralFormOpen}
            handleClose={(): void => handleToggleReferralModal(false)}
          />
        }
      </div>
    </div>
  );
};

export const SettingsPageAccount = (props: PropsType): React.Element<'div'> => {
  const context = React.useContext(DefaultContainerContext);

  const isPaymentModalOpenByDefault = _.get(props, 'history.location.state.isPaymentModalOpen', false);
  const isPageOrdModalOpenByDefault = _.get(props, 'history.location.state.isPageOrdModalOpen', false);

  window.history.replaceState({}, document.title); // remove history.location.state

  return (
    <div className="sparxo-router-content">
      <div className="sparxo-page-container SettingsPage">
        <SettingsNavigation viewTab={'account'} />
        <div>
          <SettingsPagePayment context={context} isModalOpenByDefault={isPaymentModalOpenByDefault} />

          <SettingsPageLang context={context} />

          <SettingsPageOrg context={context} isModalOpenByDefault={isPageOrdModalOpenByDefault} />
        </div>
      </div>
    </div>
  );
};
